const en = {
    navbar: {
        home: "Home",
        skills: "Skills",
        projects: "Projects",
        contact: "Contact me",
    },
    home: {
        code1: `0  // Kdoc documentation                                          
1   
2  // Main function of the program
3  
4  // Highly motivated to work, grow professionally
5  // and learn new things. I adapt well and
6  // quickly to new frameworks and languages.
7  // 
8  // The languages I ve used the most are Kotlin and C#,
9  // also Java, Python and Dart but in a more
10 // superficial way.
11 // 
12 // I also enjoy game development but
13 // for now I ve only done it
14 // individually.
15`,
        code2: `17
18 // @param args Whats needed for it to work upon waking up
19 fun main(args) {
20    WakeUp(args)
21 }`,
        copied: "Copied!"
    },
    skills: {
        skillsTitle:"<Skills/>",
        languajes: "Languajes",
        frameworks: "Frameworks",
        databases:"Databases",
        tools:"Tools",
        IDES:"IDES",
        versionContol:"Version Contol"
    },
    projects: {
        projectsTitle:"<Projects/>",
        casino404:`
        A full-stack project recreating a multiplayer poker.<br><br>
        The backend is developed with <strong>Spring Boot</strong> and <strong>WebSockets</strong>, 
        and the client with <strong>Compose Multiplatform</strong>.<br><br>
        Includes real-time communication, authentication, table management and game logic.<br>
        <a href="https://github.com/ftrugon/CASINO-404.git" target="_blank">View server repository</a> <br>
        <a href="https://github.com/ftrugon/TFG-Cliente.git" target="_blank">View client repository</a>
      `,
        tltb:`
        A small Unity game where the objective is to defeat a boss.<br><br>
        Learned fundamentals of vectors, collisions, enemy behavior, and movement.<br>
        <a href="https://github.com/ftrugon/To-learn-the-basics.git" target="_blank">View repository</a>
      `,
        complexfps:`
        A more advanced first-person shooter focused on movement mechanics, 
        shooting systems, enemy AI, and weapon logic.<br><br>
        <a href="https://github.com/ftrugon/Complex-FPS.git" target="_blank">View repository</a>
      `,
        pooKnight:`
        A small 2D platformer where I experimented with hitboxes, animation, and level design.<br><br>
        Also connects to an API to display the lowest time on the scoreboard.<br>
        <a href="https://github.com/ftrugon/Poo-Knight.git" target="_blank">View game repository</a> <br>
        <a href="https://github.com/ftrugon/PSP_API.git" target="_blank">View api repository</a>
      `
    },
    contactme: {
        contacTitle: "<Contact Me/>",
        alert1:"Succesfully sended!",
        alert2:"There was an error sending the message.",
        name:"Your name",
        mail:"Your mail",
        msg:"Your message",
        send:"Send!"
    }
    
};

export default en;
